export default __webpack_public_path__ + "static/media/banner-400x220-pies-rolls.e6535f3a.jpg";